import React from "react"

function IconMediaRecordColor({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="media-record-color"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-media-record-color"
      {...props}
    >
      <path
        d="M11.999 1.527c5.784 0 10.473 4.69 10.473 10.473 0 5.784-4.69 10.473-10.473 10.473S1.527 17.783 1.527 12 6.217 1.527 12 1.527zm0 1.31c-5.06 0-9.163 4.103-9.163 9.163A9.164 9.164 0 1 0 12 2.836zm0 4.489a4.675 4.675 0 1 1 0 9.35 4.675 4.675 0 0 1 0-9.35z"
        fill={color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__danger"
      />
    </svg>
  )
}

export default IconMediaRecordColor
